import merge from 'lodash.merge';
import path from 'path';
import type { IPackageJson } from 'package-json-type';
import readJson from '../../../utilities/readJson';

function deleteNullDeps(dep: Record<string, unknown>) {
  Object.keys(dep).forEach((key) => {
    if (dep[key] === null) {
      delete dep[key];
    }
  });
  return dep;
}

/**
 * Remove any dependencies or devDependencies that have a version of null.
 * This is useful for removing dependencies that are not to be used when building
 * in ToDesktop. For example this will remove the `electron-builder` dev dependency
 * from the package.json file when building in ToDesktop:
 * {
 *   "devDependencies": {
 *     "electron-builder": null
 *   }
 * }
 */
function removeNullDependencies(pkgJson: Record<string, any>) {
  const { dependencies, devDependencies } = pkgJson;

  if (dependencies) {
    pkgJson.dependencies = deleteNullDeps(dependencies);
  }

  if (devDependencies) {
    pkgJson.devDependencies = deleteNullDeps(devDependencies);
  }

  return pkgJson;
}

function getAppPkgJson({
  config,
}: {
  config: Record<string, any>;
}): IPackageJson {
  const packageJsonFromConfig = config.packageJson || {};
  const extendsFrom = packageJsonFromConfig.extends || 'package.json';
  const packageJsonFromFile = readJson(path.join(config.appPath, extendsFrom));

  return removeNullDependencies(
    merge({}, packageJsonFromFile, packageJsonFromConfig),
  ) as IPackageJson;
}

export default getAppPkgJson;
